import { render, staticRenderFns } from "./FactFindLiabilityLoan.vue?vue&type=template&id=0156cd74&"
import script from "./FactFindLiabilityLoan.vue?vue&type=script&lang=ts&"
export * from "./FactFindLiabilityLoan.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports